





























import { Component, Prop, Vue } from "vue-property-decorator";
import { Image as VanImage } from "vant";
import { ICommentItem } from "@/api/types";
@Component({
  components: { VanImage }
})
export default class LiveReplyComment extends Vue {
  @Prop({ type: Array, default: () => [] })
  replyList!: ICommentItem[];

  // 是否点击展示更多
  showMore = false;
}
